import axios from 'axios';
import { setclientSessionId } from '@/lib/utils';
import md5 from 'js-md5';

axios.interceptors.request.use(
  function(config) {
    let sessionId = sessionStorage.sessionId || setclientSessionId();
    let safeCode = sessionStorage.safeCode;
    let t = Date.now();
    config.headers['t'] = t;
    config.headers['clientSession'] = sessionId;
    config.headers['client'] = 'h5';
    // config.headers['Authorization'] = `JBY ${store.state.user.userToken}`;
    config.headers['encrypt'] =
      sessionId && safeCode ? md5(safeCode + t + sessionId + 'h5') : '';
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Send a GET request to URL and return the json from the server.
export async function get(url, data = {}, headers = {}, options = {}) {
  return axios({
    method: 'get',
    url,
    params: data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a POST request to URL with json DATA and return the json from the
// server.
export async function post(url, data = {}, headers = {}, options = {}) {
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a PUT request to URL with json DATA and return the json from the
// server.
export async function patch(url, data = {}, headers = {}, options = {}) {
  return axios({
    method: 'patch',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

// Send a DELETE request to URL and return the json from the server.
export async function del(url, data = {}, headers = {}, options = {}) {
  return axios({
    method: 'delete',
    url,
    data,
    headers: {
      ...headers,
    },
    ...options,
  }).then((res) => {
    return res.data;
  });
}

export async function download(url, data = {}, headers = {}, options = {}) {
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      ...headers,
    },
    responseType: 'blob',
    ...options,
  }).then((res) => {
    return res.data;
  });
}
